import { useCurrentUser } from '~/src/common/user';
import { useLocale } from '~/src/components/LocaleProvider';

import { getHomePathname } from './getHomePathname';

export function useHomePathname() {
  const { isLoggedIn, loading } = useCurrentUser();
  const { locale } = useLocale();
  const homePathName = getHomePathname(!loading && isLoggedIn, locale);
  return homePathName;
}
